import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

import { CreateWorkOrderLineItemSchema } from "./create-work-order";

export const SowChangeCreateWorkOrdersTaskAttemptFormSchema = z.object({
  type: z.literal(TaskType.SOW_CHANGE_CREATE_WORK_ORDERS),
  workOrders: z
    .array(
      z.object({
        projectId: z.number().int(),
        specialInstructions: z.string(),
        workOrderLineItems: z.array(CreateWorkOrderLineItemSchema),
        concessionSelections: z.array(z.object({ concessionId: z.string(), include: z.boolean() })).optional(),
      }),
    )
    .min(1),
});

export type SowChangeCreateWorkOrdersTaskAttemptForm = z.infer<typeof SowChangeCreateWorkOrdersTaskAttemptFormSchema>;

export const SowChangeCreateWorkOrdersTaskAttemptSchema = z.object({
  type: z.literal(TaskType.SOW_CHANGE_CREATE_WORK_ORDERS),
  workOrders: z.array(
    z.object({
      projectId: z.number().int(),
      workOrderId: z.number(),
      totalAmount: z.number(),
      lineItemCount: z.number().int().nonnegative(),
    }),
  ),
});
